import axios from "axios";

const rawUrl = process.env.REACT_APP_BACKEND_URL || "";
// Mixed-Content-Schutz: http:// → https:// erzwingen (außer localhost)
const BACKEND_URL = rawUrl.startsWith("http://") && !rawUrl.includes("localhost")
  ? rawUrl.replace("http://", "https://")
  : rawUrl;

// Wird von AuthContext gesetzt, sobald ein Auth0-Token vorhanden ist
let _authToken = null;
export function setAuthToken(token) {
  _authToken = token;
}

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Auth0 Bearer-Token automatisch an alle Admin-Requests anhängen
api.interceptors.request.use((config) => {
  if (_authToken) {
    config.headers.Authorization = `Bearer ${_authToken}`;
  }
  return config;
});

export default api;
export { BACKEND_URL };
